import React from 'react'

const GlobalFilter = ({ filter, setFilter, placeholderText, className }) => {
  return (
    <input
      type="text"
      value={filter || ""}
      onChange={(e) => setFilter(e.target.value)}
      className={className}
      placeholder={placeholderText}
    />
  )
}

export default GlobalFilter
